import React, { useEffect, useState, useMemo } from 'react'
import { Table, Header, Button, Menu, Icon } from 'semantic-ui-react'
import _ from 'lodash'
import './RelatorioTabela.scss'
import { numFormat } from '@rededompedro/utils'
import request from 'services/http'
import { finalize, tap } from 'rxjs/operators'
import { useSubscription } from 'utils'
import { DateTime } from 'luxon'
import ModalItem from './ModalItem'

export default function RelatorioTabela({ dados, form, limpar, props }) {

    const [isSubmitting, setIsSubmitting] = useState(false)
    const [nControle, setNControle] = useState(null)
    const [lista, setLista] = useState([])
    const [showModalItem, setShowModalItem] = useState(false)
    const [itemLista, setItemLista] = useState(null)
    const [restOptions,] = useState([
        { text: 'Restaurante Dom Pedro 1', value: '01' },
        { text: 'Restaurante Dom Pedro Atibaia', value: '04' },
        { text: 'Hotel Central', value: '08' },
    ])

    useEffect(() => {
        if (nControle !== null) {
            setIsSubmitting(true)
        }
    }, [nControle])

    const submitRelatorio$ = useMemo(() => request({
        url: '/contas-a-pagar/relatorio/itens',
        method: 'GET',
        params: { nControle, ...form }
    }).pipe(
        tap(({ response }) => {
            setLista(response.data)
        }),
        finalize(() => setIsSubmitting(false))
    ), [nControle, form])
    useSubscription(submitRelatorio$, isSubmitting)

    function getSomaValor(dado) {
        let aux = null
        dado.map((x) => (
            aux += x.valor
        ))
        return numFormat(parseFloat(aux))
    }

    function getItens(numero) {
        setNControle(numero)
    }

    function getNomeRestaurante() {
        let aux = restOptions.find(nome => nome.value === form.restaurante)
        return aux.text
    }

    function getDiffData(dados) {
        let end = DateTime.fromFormat(dados.data_pagto, 'dd/MM/yyyy')
        let start = DateTime.fromFormat(dados.data_vencto, 'dd/MM/yyyy')
        let x = end.diff(start, 'days')
        return x.values.days
    }

    function openModalItem(item) {
        setItemLista(item)
    }

    useEffect(() => {
        if (itemLista !== null) {
            setShowModalItem(true)
        }
    }, [itemLista])

    useEffect(() => {
        if(props.location.search){
            const aux = new URLSearchParams(props.location.search).get('tipo-data');
            if (aux === 'id_data_emi') {
                console.log(1, aux);
                return
            } else if(aux === 'id_data_vencto') {
                console.log(2, aux);
                return
            } else {
                console.log('Não achou')
            }
        }
    }, [props.location.search])

    return (
        <>
            <Menu size='mini' secondary style={{ margin: 0 }}>
                <Menu.Item style={{ padding: '12px 0px', margin: 0 }}>
                    <Button icon labelPosition='left' onClick={() => limpar()}>
                        <Icon name='trash' />
                       Limpar
                    </Button>
                </Menu.Item>
                <Menu.Menu position='right'>
                    <Menu.Item style={{ padding: '12px 0px', margin: 0 }}>
                        {lista.length <= 0 ? (
                            <Header floated='right' as='h5' textAlign='right'>
                                Período de {form.tipoData === 'id_data_emi' ? 'EMISSÃO' : form.tipoData === 'id_data_vencto' ? 'VENCIMENTO' : 'PAGAMENTO'}: {form.dataIni} até {form.dataFim}
                                <Header.Subheader style={{ color: '#db6023' }}>
                                    {getNomeRestaurante()}
                                </Header.Subheader>
                            </Header>
                        ) :
                            <Header floated='right' as='h5' textAlign='right'>
                                Nº Controle: {lista[0].n_controle}
                                <Header.Subheader style={{ color: '#db6023' }}>
                                    {getNomeRestaurante()}
                                </Header.Subheader>
                            </Header>
                        }

                    </Menu.Item>
                </Menu.Menu>
            </Menu>
            {lista.length <= 0 ? (
                <Table color='grey' singleLine className='mb-5' textAlign='center' compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Data Emissão</Table.HeaderCell>
                            <Table.HeaderCell>Data Vencto</Table.HeaderCell>
                            <Table.HeaderCell>Data Pagto</Table.HeaderCell>
                            <Table.HeaderCell>Dif. Vencto x Pagto</Table.HeaderCell>
                            <Table.HeaderCell>Nº Controle</Table.HeaderCell>
                            {form.item === 2 &&
                                <>
                                    <Table.HeaderCell>Descrição</Table.HeaderCell>
                                    <Table.HeaderCell>Nº Docto</Table.HeaderCell>
                                </>
                            }
                            <Table.HeaderCell>Valor</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {_.map(dados, ({ data_emi, data_vencto, data_pagto, n_controle, docto, valor, descricao, id_data_vencto, id_data_pagto }, index) => (
                            <Table.Row key={index}>
                                <Table.Cell>{data_emi}</Table.Cell>
                                <Table.Cell>{data_vencto}</Table.Cell>
                                <Table.Cell>{data_pagto ? data_pagto : '-'}</Table.Cell>
                                <Table.Cell>{data_pagto && data_pagto !== data_vencto ? getDiffData(dados[index]) : 0}</Table.Cell>
                                <Table.Cell>
                                    {form.item === 1 ? (
                                        <Button style={{ fontWeight: 'bold' }} basic color='blue' size='tiny' onClick={() => getItens(dados[index].n_controle)}>
                                            {n_controle}
                                        </Button>
                                    ) :
                                        n_controle
                                    }
                                </Table.Cell>
                                {form.item === 2 &&
                                    <>
                                        <Table.Cell>{descricao}</Table.Cell>
                                        <Table.Cell>
                                            {form.item === 2 ? (
                                                <Button basic color='blue' size='tiny' onClick={() => openModalItem(dados[index])}>
                                                    {docto}
                                                </Button>
                                            ) :
                                                docto
                                            }
                                        </Table.Cell>
                                    </>
                                }
                                <Table.Cell>{numFormat(valor)}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>

                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='8'>
                                <Header floated='right' color='blue' style={{ font: 'Ubuntu' }}>
                                    Total no Período: R$ {getSomaValor(dados)}
                                </Header>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            ) :
                <Table color='blue' singleLine className='mb-5' textAlign='center'>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan='8'>Lista de Itens de Pagamento</Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell>Nº Item</Table.HeaderCell>
                            <Table.HeaderCell>data Emissão</Table.HeaderCell>
                            <Table.HeaderCell>Data Vencto</Table.HeaderCell>
                            <Table.HeaderCell>Docto</Table.HeaderCell>
                            <Table.HeaderCell>Tipo</Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell>
                            <Table.HeaderCell>Observação</Table.HeaderCell>
                            <Table.HeaderCell>Valor</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {_.map(lista, ({ item_pagto, data_emi, data_vencto, docto, status, obs, valor, descricao }, index) => (
                            <Table.Row key={index}>
                                <Table.Cell>
                                    <Button style={{ fontWeight: 'bold' }} basic color='orange' size='tiny' onClick={() => openModalItem(lista[index])}>
                                        {item_pagto}
                                    </Button>
                                </Table.Cell>
                                <Table.Cell>{data_emi}</Table.Cell>
                                <Table.Cell>{data_vencto}</Table.Cell>
                                <Table.Cell>{docto}</Table.Cell>
                                <Table.Cell>{descricao}</Table.Cell>
                                <Table.Cell>{status === 1 ? 'Baixado' : 'Em aberto'}</Table.Cell>
                                <Table.Cell>{obs}</Table.Cell>
                                <Table.Cell>{numFormat(valor)}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>

                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='8'>
                                <Header floated='right' color='blue' style={{ font: 'Ubuntu' }}>
                                    Total no Período: R$ {getSomaValor(lista)}
                                </Header>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            }

            {showModalItem === true &&
                <ModalItem item={itemLista} setItemLista={setItemLista} restaurante={getNomeRestaurante()} setShowModalItem={setShowModalItem} />
            }
        </>
    )
}
